<template>
  <div class="content_pages" id="report-individual" v-if="list">
    <div class="table_bordered-header clearfix">
      <span class="table_bordered-title">
        <i class="kp-panel-check"></i>
        {{ list.quantity_of_submissions }} {{ $t('report.individual.obtained_answers') }}
      </span>
      <div class="content_filter">
        <export-button></export-button>
        <date-filter></date-filter>
      </div>
    </div>
    <modal-export-table></modal-export-table>
    <modal-cant-export-table></modal-cant-export-table>
    <modal-export-in-progress :email="reportExportEmail"></modal-export-in-progress>
    <list></list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DateFilter from './DateFilter.vue';
import ExportButton from './ExportButton.vue';
import List from './List.vue';
import ModalExportTable from '../../modal/ExportTable.vue';
import ModalCantExportTable from '../../modal/CantExportTable.vue';
import ModalExportInProgress from 'src/components/modal/ExportTableInProgress.vue';

export default {
  created() {
    this.$store.dispatch('boxGet')
      .then(() => {
        this.$store.dispatch('reportSetAnswers');
      });
  },
  components: {
    DateFilter,
    ExportButton,
    List,
    ModalExportTable,
    ModalCantExportTable,
    ModalExportInProgress,
  },
  computed: mapGetters({
    reportExportEmail: 'reportExportEmail',
    list: 'reportList',
  }),
};
</script>




/** WEBPACK FOOTER **
 ** Main.vue?8cf5bfcc
 **/